import React, { useEffect, useState } from 'react';
import { BookOpen } from 'lucide-react';
import { cx } from '../ui/utils';
import './CourseThumbnail.css';

// Kurs/dars rasmi. Rasm yo'q yoki yuklanmasa (onError) — o'sha o'lchamdagi kulrang placeholder
// va markazda BookOpen ikonkasi. O'lcham chaqiruvchi className orqali beriladi.
function CourseThumbnail({ src, alt = '', className, ...rest }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return (
      <span
        className={cx('ui-thumb', 'ui-thumb--empty', className)}
        role={alt ? 'img' : undefined}
        aria-label={alt || undefined}
        aria-hidden={alt ? undefined : true}
      >
        <BookOpen aria-hidden="true" />
      </span>
    );
  }

  return (
    <img
      {...rest}
      src={src}
      alt={alt}
      loading="lazy"
      className={cx('ui-thumb', className)}
      onError={() => setFailed(true)}
    />
  );
}

export default CourseThumbnail;
